import dialogPolyfill from "dialog-polyfill";

(function () {
    const hash = window.location.hash;

    const initOverlay = (element) => {
        let dialog = element.querySelector("dialog");
        let openDialogButton = element.querySelector(".js-anchor");
        dialogPolyfill.registerDialog(dialog);

        openDialogButton.addEventListener("click", (e) => {
            e.preventDefault();
            document.location.hash = dialog.getAttribute("id");

            if (!dialog.open) {
                dialog.showModal();
            }
        });

        dialog.addEventListener("close", (e) => {
            e.preventDefault();
            removeHashFromUrl();
            closeAllDialogs();
        });

        setTimeout(() => {
            if (hash && hash === "#" + dialog.getAttribute("id")) {
                try {
                    // needed if the overlay is located in the accordion tabs..
                    if (window.outerWidth >= 768) {
                        if (dialog.closest("[data-accordiontabs-index]")) {
                            let accordiontabsIndex = dialog.closest("[data-accordiontabs-index]").dataset.accordiontabsIndex;
                            let tabContainer = dialog.closest('[x-data="openTab"]');

                            window.scroll({
                                top: tabContainer.getBoundingClientRect().top + window.scrollY - 300,
                                left: 0,
                                behavior: "smooth",
                            });

                            tabContainer
                                .querySelector('[role="tablist"] [data-accordiontabs-index="' + accordiontabsIndex + '"]')
                                .click();
                        }
                    } else {
                        window.scroll({
                            top: dialog.closest("details").getBoundingClientRect().top + window.scrollY - 300,
                            left: 0,
                            behavior: "smooth",
                        });

                        if (dialog.closest("details")) {
                            dialog.closest("details").querySelector("summary").click();
                        }
                    }
                } catch (e) {
                    // ignore..
                }

                setTimeout(() => {
                    if (hash && dialog) {
                        if (!dialog.open) {
                            if (window.outerWidth >= 768) {
                                document
                                    .querySelector('[x-data="openTab"] [href="#' + dialog.getAttribute("id") + '"]')
                                    .click();
                            } else {
                                document.querySelector('details [href="#' + dialog.getAttribute("id") + '"]').click();
                            }
                        }
                    }
                }, 250);
            }
        }, 250);
    };

    const addObserver = (element) => {
        const observerCallback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (
                    mutation.type === "childList" &&
                    mutation.addedNodes &&
                    mutation.addedNodes.length > 0 &&
                    mutation.addedNodes[0].classList &&
                    mutation.addedNodes[0].classList.contains("js-overlay")
                ) {
                    initOverlay(mutation.addedNodes[0]);
                }
            }
        };

        const observer = new MutationObserver(observerCallback);
        const targetNode = element.parentElement;
        const config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
    };

    const removeHashFromUrl = () => {
        let uri = window.location.toString();
        if (uri.indexOf("#") > 0) {
            let clean_uri = uri.substring(0, uri.indexOf("#"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    };

    const closeAllDialogs = () => {
        document.querySelectorAll("dialog").forEach((elem) => {
            elem.close();
        });
    };

    const overlay = document.querySelectorAll(".js-overlay");
    if (overlay.length > 0) {
        overlay.forEach(initOverlay);
    }

    addObserver(document.body);
})();
